// Teen Patti 20-20 — frontend GameModule. Dark-launch: games.is_locked=1.
import type { GameModule } from '../types';
import Page from './Page';

const teenPatti: GameModule = {
  id: 'teen_patti',
  displayName: 'Teen Patti 20-20',
  tag: 'Casino',
  theme: { gradient: 'from-amber-500 to-rose-900', emoji: '🃏', logo: '/games/teen_patti/Logo.png' },
  orientation: 'portrait',
  adminIcon: 'style',
  adminTheme: {
    headerFrom: 'from-rose-950', headerTo: 'to-amber-700',
    ring: 'ring-amber-400', accent: 'bg-amber-600', accentHover: 'hover:bg-amber-500',
    dot: 'bg-amber-400', softBg: 'bg-amber-900/30', rangeAccent: 'accent-amber-500',
    badgeClasses: 'bg-amber-600/20 text-amber-300 border-amber-600/30',
  },
  Page,
};

export default teenPatti;
